
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Localsightseeingcabsinpune() {



    const cardData =
    {
        keyword: 'Local Sightseeing Cabs in Pune',
        heading: 'Platinum24 Cabs: Local Sightseeing Cabs in Pune',
        headingDescription: ' Platinum24 Cabs offers comfortable Local Sightseeing Cabs in Pune, making it easy to explore the city’s heritage spots, temples, shopping hubs, and modern attractions. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a smooth travel experience with spacious seating and air-conditioned comfort. With professional chauffeurs who know Pune’s best routes and tourist highlights, we guarantee timely pickups and a hassle-free journey. Whether you’re visiting Shaniwar Wada, Aga Khan Palace, Dagdusheth Halwai Ganpati, or popular malls, Platinum24 Cabs provides affordable fares, flexible packages, and reliable service for all your local sightseeing needs.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, it showcases grand gateways, fountains, and gardens. Though partially destroyed by fire in 1828, its ruins still narrate tales of Bajirao and Mastani. The evening light-and-sound show recreates Maratha history. Tourists love exploring its majestic corridors and courtyards. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument with Italian arches and sprawling gardens. It is historically significant as Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. The palace houses a museum displaying Gandhi’s personal items and photographs. Its calm ambiance attracts history and peace seekers. The palace is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s historic gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The fort sits atop a hill, offering trekking trails and panoramic views of the Sahyadris. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon adds mist and waterfalls, enhancing its beauty. Local villagers serve rustic delicacies like pithla-bhakri at the top. Sinhagad is Pune’s perfect blend of history and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The magnificent idol is adorned with gold and ornaments, attracting devotees year-round. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. It is also known for charitable and cultural initiatives. The vibrant spiritual aura makes it a must-visit. Dagdusheth Temple is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is dedicated to Lord Shiva. It features rock-cut architecture with massive stone pillars, a sanctum, and a Nandi mandapa. Located in the city center, it offers a peaceful retreat from urban life. Evening prayers and chants create a mystical ambiance. Its ancient carvings reflect early Indian craftsmanship. Pataleshwar is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a cultural treasure showcasing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, musical instruments, sculptures, and daily-use antiques. The recreated Mastani Mahal is the highlight for visitors. History lovers and students find it fascinating and educational. The museum preserves centuries of Indian culture and traditions. It is Pune’s proud showcase of heritage and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers a panoramic view of the city. At the hilltop stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the temple, making it a mix of devotion and adventure. The site also houses smaller shrines and a museum. Sunrise and sunset views are mesmerizing from here. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for spirituality and wellness. Spread across lush gardens, it attracts seekers from around the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and peaceful meditation halls add to its charm. Visitors experience rejuvenation and mindfulness here. Osho Ashram is Pune’s international wellness destination."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and lush green lawns. Families enjoy peaceful walks, photography, and picnics here. The garden symbolizes Indo-Japanese cultural friendship. Seasonal flowers and manicured spaces attract nature lovers. Pu La Deshpande Garden is Pune’s green oasis of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend destination near Pune. It supplies water to the city while offering scenic views of hills and flowing waters. Monsoon transforms it into a picturesque spot with overflowing streams. Street vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],



         "services": [
    {
      "name": "Pune Local Sightseeing Cabs",
      "description": "Explore the vibrant city of Pune with our reliable local sightseeing cab services. Whether you're a tourist or a resident, our comfortable and affordable cabs are perfect for visiting top attractions like Shaniwar Wada, Aga Khan Palace, Dagdusheth Ganpati Temple, and more. Enjoy hassle-free, flexible rides tailored to your schedule."
    },
    {
      "name": "Sightseeing Taxi Pune",
      "description": "Book a sightseeing taxi in Pune to discover the rich culture, heritage sites, and scenic spots at your own pace. Our professional drivers ensure timely pickups and personalized tour routes that cover all the must-see locations across the city and nearby areas."
    },
    {
      "name": "Pune City Tour Taxi",
      "description": "Experience Pune’s charm with our exclusive city tour taxi service. From historical landmarks to vibrant markets and serene gardens, travel comfortably with an expert driver who can provide local insights and help you make the most of your visit."
    },
    {
      "name": "Pune Sightseeing Car Rental",
      "description": "Rent a car in Pune specifically for sightseeing purposes, with options including sedans, SUVs, and luxury cars. Our sightseeing car rental service offers clean, well-maintained vehicles along with friendly drivers to ensure a memorable travel experience."
    },
    {
      "name": "Local Tour Taxi Pune",
      "description": "Discover Pune’s hidden gems and popular tourist spots with our local tour taxi service. Whether it’s a day trip or a weekend getaway, we provide reliable, affordable cabs with flexible itineraries to suit your interests and time."
    },
    {
      "name": "Affordable Sightseeing Cabs Pune",
      "description": "Get the best value for your sightseeing trips in Pune with our affordable cab services. Enjoy comfortable rides without compromising on quality or service, perfect for solo travelers, families, and groups alike."
    },
    {
      "name": "Pune Sightseeing Cab Booking",
      "description": "Easily book your Pune sightseeing cab online or via phone for a smooth and convenient travel experience. Our booking process is simple, with instant confirmations and transparent pricing so you can plan your trips confidently."
    },
    {
      "name": "Pune Tourist Taxi Service",
      "description": "Our Pune tourist taxi service is designed to cater specifically to travelers wanting to explore the city's cultural and historical highlights. Choose from customized packages including half-day, full-day, or multi-day tours with experienced drivers."
    },
    {
      "name": "Sightseeing Taxi with Driver Pune",
      "description": "Enjoy a stress-free sightseeing tour in Pune with a professional driver who knows the best routes and timings. Our taxis come with courteous drivers ensuring your safety, comfort, and timely arrivals at all major destinations."
    },
    {
      "name": "Pune Local Tourist Cab",
      "description": "Hire a local tourist cab in Pune for city sightseeing, weekend trips, or visiting nearby tourist attractions. Our fleet includes well-maintained vehicles equipped with all amenities to provide you a pleasant journey."
    },
    {
      "name": "Pune Heritage Tour Cabs",
      "description": "Explore Pune’s rich heritage with our specialized heritage tour cabs. Visit historical sites like Shaniwar Wada, Lal Mahal, and Pataleshwar Cave Temple with knowledgeable drivers who can share fascinating stories and facts."
    },
    {
      "name": "Pune Sightseeing Packages",
      "description": "Choose from a variety of sightseeing packages in Pune tailored to your interests and duration. Packages include visits to cultural landmarks, museums, parks, and more, with all transportation and driver charges included."
    },
    {
      "name": "Pune Local Travel Taxi",
      "description": "For all your local travel needs in Pune, our taxi service offers reliable, punctual, and affordable rides. Ideal for daily commuting, shopping trips, and local sightseeing without the hassle of driving."
    },
    {
      "name": "Pune Weekend Sightseeing Cabs",
      "description": "Plan your weekend trips around Pune with our sightseeing cabs specially designed for short getaways. Visit nearby attractions like Lonavala, Khandala, or Mulshi Lake with comfortable rides and expert drivers."
    },
    {
      "name": "Pune Local Cab for Sightseeing",
      "description": "Book a local cab in Pune for sightseeing and explore the city’s beauty at your convenience. Our cabs are available 24/7 with flexible timings, ensuring you get the best travel experience every time."
    }
  ],
  "tableData": [
    ["Pune Local Sightseeing Cabs", "Sightseeing Taxi Pune"],
    ["Pune City Tour Taxi", "Pune Sightseeing Car Rental"],
    ["Local Tour Taxi Pune", "Affordable Sightseeing Cabs Pune"],
    ["Pune Sightseeing Cab Booking", "Pune Tourist Taxi Service"],
    ["Sightseeing Taxi with Driver Pune", "Pune Local Tourist Cab"],
    ["Pune Heritage Tour Cabs", "Pune Sightseeing Packages"],
    ["Pune Local Travel Taxi", "Pune Weekend Sightseeing Cabs"],
    ["Pune Local Cab for Sightseeing", "—"]
  ],


        "whychoose": [
    {
      "WhyChooseheading": "Comfortable Local Sightseeing Cabs in Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers reliable and comfortable cab services for exploring Pune’s top tourist attractions."
    },
    {
      "WhyChooseheading": "Customizable Sightseeing Packages",
      "WhyChoosedescription": "Choose from half-day, full-day, or customized sightseeing tours based on your interests and time."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Local Knowledge",
      "WhyChoosedescription": "Our drivers are well-versed with Pune's tourist spots and can guide you throughout your trip."
    },
    {
      "WhyChooseheading": "Clean and Air-Conditioned Vehicles for Comfort",
      "WhyChoosedescription": "All our cabs are sanitized, well-maintained, and equipped with air-conditioning for a pleasant ride."
    },
    {
      "WhyChooseheading": "Ideal for Solo Travelers, Families, and Groups",
      "WhyChoosedescription": "We offer vehicle options suitable for all group sizes, from solo explorers to family outings."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
      "WhyChoosedescription": "Enjoy clear and upfront pricing with no surprise charges during your sightseeing tour."
    },
    {
      "WhyChooseheading": "24/7 Booking Support and Assistance",
      "WhyChoosedescription": "Book your sightseeing cab anytime with our round-the-clock customer support."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Preference",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or tempo travellers based on your comfort and group size."
    }
  ]








































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer local sightseeing cab services in Pune?',
        answer: 'Yes, Platinum24 Cabs provides convenient and affordable cab services for local sightseeing tours within Pune city and nearby attractions.',
    },
    {
        question: 'What are the popular local sightseeing spots in Pune covered by your cabs?',
        answer: 'Our sightseeing cabs can take you to major attractions like Shaniwar Wada, Aga Khan Palace, Sinhagad Fort, Dagdusheth Halwai Ganpati Temple, Parvati Hill, and more.',
    },
    {
        question: 'What types of vehicles are available for local sightseeing in Pune?',
        answer: 'We offer a wide range of vehicles including sedans, SUVs, and tempo travellers based on your group size and comfort requirements.',
    },
    {
        question: 'Can I book a cab for half-day or full-day sightseeing in Pune?',
        answer: 'Yes, we offer flexible packages for half-day, full-day, and hourly rental sightseeing tours depending on your schedule and preferences.',
    },
    {
        question: 'Are the drivers knowledgeable about local tourist places in Pune?',
        answer: 'Yes, our drivers are experienced and familiar with the city’s key tourist spots, helping you plan your route efficiently.',
    },
    {
        question: 'How do I book a sightseeing cab in Pune with Platinum24 Cabs?',
        answer: 'You can easily book your sightseeing cab through our website, mobile app, or by calling our customer support.',
    },
    {
        question: 'Is advance booking required for local sightseeing cabs in Pune?',
        answer: 'While we do accept last-minute bookings, we recommend advance reservations for better vehicle availability and a hassle-free experience.',
    },
    {
        question: 'Are the cabs sanitized and safe for family sightseeing tours?',
        answer: 'Absolutely! All our vehicles are regularly sanitized, and our drivers follow strict hygiene and safety protocols.',
    },
    {
        question: 'Can I customize the sightseeing itinerary for my Pune city tour?',
        answer: 'Yes, we offer customizable itineraries so you can choose the attractions and schedule that best suit your interests.',
    },
    {
        question: 'Do you provide guided sightseeing tours along with cab services?',
        answer: 'While our drivers are knowledgeable, we can arrange professional tour guides on request for a more detailed experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Kunal Patil',
        feedback: 'We booked a cab for local sightseeing in Pune with Platinum24 Cabs. The service was excellent and the driver was very helpful.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Mrs. Anjali Naik',
        feedback: 'Great sightseeing experience in Pune! Clean cab, courteous driver, and well-planned route. Highly recommended.',
        rating: 5,
    },
];


















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];





const localSightseeingSchema = {
  "@context": "https://schema.org",
  "@type": "TouristInformationCenter",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Local Sightseeing Cabs in Pune offering affordable and reliable city tour taxi services, heritage tours, and sightseeing packages with experienced drivers.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "telephone": "+91-XXXXXXXXXX",
  "serviceType": [
    "Pune Local Sightseeing Cabs",
    "Sightseeing Taxi Pune",
    "Pune City Tour Taxi",
    "Pune Sightseeing Car Rental",
    "Local Tour Taxi Pune",
    "Affordable Sightseeing Cabs Pune",
    "Pune Sightseeing Cab Booking",
    "Pune Tourist Taxi Service",
    "Sightseeing Taxi with Driver Pune",
    "Pune Local Tourist Cab",
    "Pune Heritage Tour Cabs",
    "Pune Sightseeing Packages",
    "Pune Local Travel Taxi",
    "Pune Weekend Sightseeing Cabs",
    "Pune Local Cab for Sightseeing"
  ]
};








    return (
        <div>

<Helmet>
  <title>Local Sightseeing Cabs in Pune | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Local Sightseeing Cabs in Pune offering affordable and reliable city tour taxi services, heritage tours, and sightseeing packages with experienced drivers."
  />
  <meta
    name="keywords"
    content="Pune Local Sightseeing Cabs, Sightseeing Taxi Pune, Pune City Tour Taxi, Pune Sightseeing Car Rental, Local Tour Taxi Pune, Affordable Sightseeing Cabs Pune, Pune Sightseeing Cab Booking, Pune Tourist Taxi Service, Sightseeing Taxi with Driver Pune, Pune Local Tourist Cab, Pune Heritage Tour Cabs, Pune Sightseeing Packages, Pune Local Travel Taxi, Pune Weekend Sightseeing Cabs, Pune Local Cab for Sightseeing"
  />
  <script type="application/ld+json">
    {JSON.stringify(localSightseeingSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/45.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Localsightseeingcabsinpune;